import React from 'react';
import { Avatar, Card, CardHeader, Stack, Typography } from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import NotFound from './NotFound';

export default function Products({ type, products, categories }) {
  if (products.length === 0 && categories.length === 0) {
    return <NotFound />;
  }

  return (
    <Stack rowGap={0.5}>
      {type === 'ALL_PRODUCT' && <Alert title="این بن شامل همه محصولات فروشگاه می باشد." />}
      {type === 'SELECTED_PRODUCT' && <Alert title="این بن تنها شامل محصولات زیر می باشد." />}
      {categories && categories.map((item, i) => <CategoryCard key={i} category={item} />)}
      {products.map((item, i) => (
        <ProductCard key={i} {...item} />
      ))}
    </Stack>
  );
}

function Alert({ title }) {
  return (
    <Card sx={{ bgcolor: 'warning.lighter', mb: 1 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'warning.lighter' }}>
            <WarningRoundedIcon color="warning" fontSize="small" />
          </Avatar>
        }
        subheader={<Typography variant="caption">{title}</Typography>}
      />
    </Card>
  );
}

function ProductCard({ id, product_info }) {
  const { title, brand, media } = product_info;
  const img = media[0]?.full_url || '/assets/images/picture.png';
  return (
    <Card sx={{ width: '100%' }}>
      <CardHeader
        title={
          <Typography fontSize={14} variant="subtitle1">
            {`${title} ${brand?.title || ''}`}
          </Typography>
        }
        avatar={<Avatar sx={{ bgcolor: 'action.hover' }} src={img} />}
        // action={
        //   <IconButton color="error" disabled={loading} size="small" onClick={() => onDelete(id)}>
        //     <DeleteOutlineRounded fontSize="small" />
        //   </IconButton>
        // }
      />
    </Card>
  );
}

function CategoryCard({ category }) {
  const media = category.media[0]?.full_url;
  const img = media || '/assets/images/picture.png';
  return (
    <Card sx={{ width: '100%', bgcolor: 'warning.lighter' }}>
      <CardHeader
        avatar={<Avatar src={img} />}
        subheader={
          <Typography variant="caption" component="p">
            این بن شامل همه محصولات گروه
            <Typography variant="subtitle1" component="span" color="primary.main">
              {` ${category.title} `}
            </Typography>
            می باشد.
          </Typography>
        }
      />
    </Card>
  );
}
